import { render, staticRenderFns } from "./ButtonPrimary.vue?vue&type=template&id=020a25ba&"
import script from "./ButtonPrimary.vue?vue&type=script&lang=ts&"
export * from "./ButtonPrimary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports